import { Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material';
import ThemedCard from 'src/e2e-redesign/components/ThemedCard';
import { handlePaymentOption, PaymentType } from './payment-options-logic';
import PaymentOptionImageContainer from './payment-option-image-container';
import { useParams } from 'react-router-dom';
import { useState } from 'react';
import PaymentErrorModal from './payment-error-modal';
import CircularProgress from '@mui/material/CircularProgress';

const paymentTypeContent: Record<PaymentType, { title: string; description: string }> = {
  split: {
    title: 'Pay by Credit Card or ACH',
    description: 'Split the payments with your credit card or set up ACH payments.',
  },
  oneTime: {
    title: 'Pay in Full',
    description: 'Make a one-time payment using your preferred method.',
  },
};

export default function PaymentOptionsCard() {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
  const rawPaymentType = window.localStorage.getItem('paymentType');
  const isValidPaymentType = rawPaymentType === 'split' || rawPaymentType === 'oneTime';
  const paymentType = isValidPaymentType ? (rawPaymentType as PaymentType) : null;
  const { aaso_id, store_uuid } = useParams();
  console.log('aaso_id', aaso_id);
  console.log('store_uuid', store_uuid);
  const sent_form_id = window.localStorage.getItem('source');
  console.log('sent_form_id', sent_form_id);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const onPayNowClick = async () => {
    if (!aaso_id || !store_uuid || !sent_form_id) {
      throw new Error('Missing required parameters');
      return;
    }
    setLoading(true);
    try {
      const response = await handlePaymentOption({
        aaso_id,
        sent_form_id,
        store_uuid,
      });
      const {lender_additional_details} = response;
      const {redirect_url} = lender_additional_details || {};
      if (redirect_url) {
        window.location.replace(redirect_url);
      } else {
        setErrorModalOpen(true); 
      }
    } catch (error) {
      setErrorModalOpen(true);
    } finally {
      setLoading(false);
    }
  };
  return (
    <ThemedCard>
      {paymentType ? (
        <>
          <Typography variant="h2" component="h2" sx={{ marginBottom: '20px' }}>
            {paymentTypeContent[paymentType].title}
          </Typography>
          <Typography variant="body1" component="p" sx={{ marginBottom: '40px' }}>
            {paymentTypeContent[paymentType].description}
          </Typography>
        </>
      ) : (
        <>
          <Typography variant="h2" component="h2" sx={{ marginBottom: '20px', color: 'error.main' }}>
            Purchase Options Unavailable
          </Typography>
          <Typography variant="body1" component="p" sx={{ marginBottom: '40px' }}>
            Purchase options cannot be offered at this time. Please see your sales associate.
          </Typography>
        </>
      )}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'stretch', sm: 'center' },
          justifyContent: 'space-between',
          gap: 2,
          marginTop: '20px',
        }}
      >
        <PaymentOptionImageContainer />
        <Button
          variant="contained"
          color="warning"
          size={isMdUp ? 'large' : 'small'}
          sx={{ alignSelf: { xs: 'center', sm: 'center', md: 'flex-end' }, mt: { xs: 2, sm: 0 } }}
          onClick={onPayNowClick}
          disabled={!paymentType || loading}
        >
          {loading ? (
            <>
            <CircularProgress size={20} color="inherit" sx={{ mr: 1 }}/>
            Processing...
            </>
          ) : (
            'Pay Now'
          )}
        </Button>
      </Box>
      <PaymentErrorModal
        open={errorModalOpen}
        onClose={() => setErrorModalOpen(false)}
      />
    </ThemedCard>
  );
}
